import { render } from "./AssetDashboard.vue?vue&type=template&id=0bf13ec3&scoped=true"
import script from "./AssetDashboard.vue?vue&type=script&lang=js"
export * from "./AssetDashboard.vue?vue&type=script&lang=js"

import "./AssetDashboard.vue?vue&type=style&index=0&id=0bf13ec3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf13ec3"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn,QSpinner,QTooltip,QSelect,QDialog,QCard,QBar,QSpace,QCardSection,QInput,QCardActions,QTable,QField});
